/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* project.module.ts
* 5-10-2020 - Jelmer Jellema - Spin in het Web B.V.
*/

import {NgModule} from '@angular/core';
import {Projectlijstscherm} from './projectlijst';
import {ModalModule} from 'ngx-bootstrap/modal';
import {SihwtijdveldModule} from 'sihw-ng/controls/sihwtijdveld/sihwtijdveld.module';
import {Projectedit} from './projectedit';
import {SihwdatepickerModule} from 'sihw-ng/controls/sihwdatepicker/sihwdatepicker.module';
import {ColorPickerModule} from 'ngx-color-picker';
import {FormsModule} from '@angular/forms';
import {SihwDatatableModule} from 'sihw-ng/datatable/datatable.module';
import {CommonModule} from '@angular/common';

const schermen = [
  Projectlijstscherm,
  Projectedit
];

@NgModule({
  declarations: schermen,
  imports: [
    CommonModule,
    ColorPickerModule,
    ModalModule.forRoot(),
    SihwtijdveldModule,
    SihwdatepickerModule,
    FormsModule,
    SihwDatatableModule
  ],
  providers: [],
  exports: schermen
})
export class ProjectModule {
}

Projectlijstscherm.register('Projectlijstscherm');
Projectedit.register('Projectedit');
